<mat-card appearance="outlined">
  <mat-card-content>
    <ng-container *ngIf="hasProductDependencies">
      <div class="requirements-header">
        <h2 class="va-component-subtitle">
          {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PRODUCT_REQUIREMENTS.LABEL' | translate }}
        </h2>
        <mat-icon
          [glxyPopover]="productRequirementsPopover"
          (mouseenter)="showProductRequirementsPopover = true"
          (mouseleave)="showProductRequirementsPopover = false"
          inline
        >
          info_outline
        </mat-icon>
        <glxy-popover #productRequirementsPopover [isOpen]="showProductRequirementsPopover">
          <glxy-popover-title>
            {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PRODUCT_REQUIREMENTS.TOOLTIP.TITLE' | translate }}
          </glxy-popover-title>
          <ng-container *ngIf="marketingType === MarketingType.EndUser; else internalDescription">
            {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PRODUCT_REQUIREMENTS.TOOLTIP.EXTERNAL_DESCRIPTION' | translate }}
          </ng-container>
          <ng-template #internalDescription>
            {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PRODUCT_REQUIREMENTS.TOOLTIP.INTERNAL_DESCRIPTION' | translate }}
          </ng-template>
        </glxy-popover>
      </div>
      <div class="product-requirements">
        <store-required-products-list
          [product]="product"
          [marketingType]="marketingType"
          [personaType]="personaType"
          [partnerId]="partnerId"
          [marketId]="marketId"
        ></store-required-products-list>
      </div>
    </ng-container>
    <h2 class="va-component-subtitle">
      {{ 'FRONTEND.STORE.AVAILABLE_IN' | translate }}
    </h2>
    <store-supported-countries-v2
      [businessCountryCode]="businessCountryCode"
      [countryCodes]="product.restrictions.country.whitelist"
    ></store-supported-countries-v2>
  </mat-card-content>
</mat-card>
